import { render, staticRenderFns } from "./wireGeneral.vue?vue&type=template&id=b6220a6c"
import script from "./wireGeneral.vue?vue&type=script&lang=js"
export * from "./wireGeneral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports